export default __webpack_public_path__ + "static/media/localtext.76c27e22.csv";